import { AppBaseProps, CommonApp, Context, Entity } from "../../core/components/commonApp.js";
import { AppHelper } from "../../appHelper.js";
import { Helper } from "../../core/util/helper.js";
import { HTTPService, JsonResultClass } from "../../core/util/httpManager.js";
import { NotificationHelper } from "../../core/util/notificationHelper.js";
import { Config } from "../../core/config/config.js";
import { DialogHelper } from "../../core/util/dialogHelper.js";
import { KeyValuePair, StringKeyDictionary } from "../../commonInterfaces.js";
import React from "react"
export class EditFlag extends React.Component<FlagProps, any>{
    closeAfterSave: boolean;
    translations: StringKeyDictionary<string>;
    common = new AppHelper();

    constructor(props: FlagProps) {
        super(props)
        this.closeAfterSave = props.closeAfterSave;
        this.common.enableHooks = false;
        this.common.init(this);
        this.props.context.translations = this.translations;
    }

    handleFieldChange = (field: { model: string }, value, dataItem = null, isInit = false) => {
        switch (field.model) {
            case "entity.Color":
                if ((value.toLowerCase() === "#000000") || (value.toLowerCase() === "#ffffff")) {
                    NotificationHelper.showWarningMessage(this.translations["WebSMS.ResourcePlanningScheduler.Flags.ColorError"]);
                    value = this.props.entity.Color;
                }
                break;
        }
        if (!isInit)
            this.common.handleFieldChange(field, value, dataItem);
    }

    private validate = async () => {
        if (!this.common.validate())
            return false;
        if ((this.props.entity.Color.toLowerCase() === "#000000") || (this.props.entity.Color.toLowerCase() === "#ffffff")) {
            NotificationHelper.showWarningMessage(this.translations["WebSMS.ResourcePlanningScheduler.Flags.ColorError"]);
            return false;
        }
        const result = await HTTPService.noBusyIndicator().get<JsonResultClass<any[]>>("PlanningBoardFlag/GetAllFlags");
        if (result.Code !== 0) {
            NotificationHelper.showErrorMessage(result.Message)
            return false;
        }
        const item = result.Data.find(f => f.Id != this.props.entity.Id && f.Color == this.props.entity.Color);
        if (!Helper.hasValue(item))
            return true;
        const isOK = await DialogHelper.confirm(this.translations["WebSMS.ResourcePlanningScheduler.Flags.ColorAlreadyUsed"].replace("{color}", item.Color).replace("{name}", item.Name))
        return isOK
    }

    save = async () => {
        const isValid = await this.validate();
        if (isValid) {
            const result = await HTTPService.post<JsonResultClass<FlagEntity>>("PlanningBoardFlag/Save", { model: this.props.entity });
            if (result.Code == 0) {
                NotificationHelper.showSuccessMessage(result.Message);
                Helper.updateEntity(this.props.entity, result.Data);
            } else {
                NotificationHelper.showErrorMessage(result.Message);
            }
            this.common.handlePostSave(result.Code === 0, this.closeAfterSave);
            this.setState({}, this.setTitle);
        }
    }

    private setTitle = () => {
        const l = Helper.hasValue(this.props.entity.Translations) ? this.props.entity.Translations.find(f => f.Key == Config.user.languageId) : null;
        const title = Helper.hasValue(l) && !Helper.isNullOrEmpty(l.Value) ? l.Value : this.props.entity.FallbackName;
        this.common.updateSheetTitle(title);
    }

    componentDidMount() {
        this.setTitle();
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { apphelper: this.common, handleFieldChange: this.handleFieldChange });
        return <CommonApp {...props} />;
    }
}

export interface FlagProps extends AppBaseProps {
    entity: FlagEntity;
    context: FlagContext;
    closeAfterSave: boolean;
}

export interface FlagContext extends Context {
    translations?: StringKeyDictionary<string>
}

export interface FlagEntity extends Entity {
    Id: string;
    Color: string;
    FallbackName: string;
    Translations: KeyValuePair<number, string>[];
    RecordRight: {
        CanRead: boolean;
        CanWrite: boolean;
        AddResources: boolean;
        AddAssignments: boolean;
    }
}